import React, { useEffect } from "react";
import Domain from "../../components/domain/Domain";
import styles from "../domainsection/domainsection.module.scss";
import ServicesProvided from "../../components/reusable/servicesProvided/ServicesProvided";
import EasySteps from "../../components/easySteps/EasySteps";
import CommonQuestions from "../../components/commonQuestions/CommonQuestions";
import Contact from "../../components/contact/Contact";
import Footer from "../footer/Footer";
import Navbar from "../../components/navbar/Navbar";

const data = [
  {
    id: 1,
    question: "What is Domain?",
    answer:
      "A domain is your unique identity on the internet. It helps user to find out your website or application easily.",
  },
  {
    id: 2,
    question: "Why do I need a domain for my website?",
    answer:
      "A domain gives credibility to your website, making it easier for users to find and trust your online presence.",
  },
  {
    id: 3,
    question: "Can I use a domain I already own with KrihaMegam?",
    answer:
      "Yes, you can connect an existing domain to your KrihaMegam account for seamless management.",
  },
  {
    id: 4,
    question: "What if the domain I want is already taken ?",
    answer:
      "You can try a different domain name or explore alternative domain extensions like .net, .org, etc",
  },
];
const Domainsection = () => {

  useEffect(() => {
    const section = document.getElementById("services");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  return (
    <div className={styles.container}>
      <Navbar />
      <Domain id="services" />
      <ServicesProvided />
      <EasySteps />
      <CommonQuestions questioData={data} />
      <Contact />
      <Footer />
    </div>
  );
};

export default Domainsection;
